import React from 'react';
import { Box, IconButton, Link, Stack, Tooltip, useTheme } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import { Warning } from '@mui/icons-material';
import { specialChars } from '@/utils/constants';
import { FileTypeIcon } from './FileTypeIcon';

export const FolderName = ({ row, setActiveFolder, handlePreview }) => {
	const theme = useTheme();
	return (
		<Tooltip title={row.isFolder ? '' : 'Double-click to edit file name'} placement='top' arrow>
			<Stack direction='row' alignItems={'center'}>
				{!row.isFolder && (specialChars.test(row.name) || row.name.length > 250) && (
					<Tooltip
						title={
							specialChars.test(row.name)
								? 'File name contains characters that could cause an error'
								: 'File name should be less than 250 characters'
						}
					>
						<Warning color='warning' sx={{ fontSize: '1.2em' }} />
					</Tooltip>
				)}
				{row.isFolder ? (
					<IconButton
						color='primary'
						onClick={() => setActiveFolder(row)}
						sx={{ color: '#fbce3a' }}
					>
						<FolderIcon />
					</IconButton>
				) : (
					<Box
						sx={{
							display: 'inline-flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: 40,
							flexShrink: 0,
						}}
					>
						<FileTypeIcon row={row} />
					</Box>
				)}
				<Link
					component='button'
					underline='hover'
					variant='body1'
					color={row.isFolder ? 'inherit' : theme.palette.primary.main}
					onClick={() => (row.isFolder ? setActiveFolder(row) : handlePreview(row))}
					noWrap
					textAlign={'left'}
				>
					{row?.name}
				</Link>
			</Stack>
		</Tooltip>
	);
};
